import { SwitchInput } from '@framework/form/inputs/SwitchInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Space } from 'antd';
import { useWatch } from 'react-hook-form';
import { type Widget } from '../../../../Widget.ts';
import { TableCellWidgetList } from './TableCellWidgetList.tsx';

export interface IRowCustomFormSwitchProps {
  columns?: Widget[];
}

export function RowCustomFormSwitch(props: IRowCustomFormSwitchProps) {
  const { columns } = props;
  const customRow = useWatch({ name: 'customRow' });

  return (
    <>
      <FormItem name="customRow" label={null}>
        <Space align="center">
          <SwitchInput name="customRow" />
          <span>Riga Personalizzata</span>
        </Space>
      </FormItem>
      {customRow && <TableCellWidgetList name="cells" columns={columns} />}
    </>
  );
}
